<template>
    <div class="notification" :class="{ hidden: !shown }">
        <template v-if="notification">
            <div v-if="notification.data.type === 'invitation_organization'" class="notification-box">
                {{ $t("You have received an invitation to join") }}: {{ notification.data.organizationName }}
                <router-link class="d-flex justify-content-end external-link me-2" :to="{ name: 'organization' }">
                    {{ $t("Show invitation") }}
                </router-link>
            </div>
            <div v-else-if="notification.data.type === 'room_join_request'" class="notification-box">
                {{ $t("User") }} {{ notification.data.requesterName }} {{ $t("has requested to join room") }} {{
                    notification.data.roomName }}
                <router-link class="d-flex justify-content-end external-link me-2"
                    :to="{ name: 'section', params: { roomId: notification.data.roomId, sectionId: 'audience' } }"
                    @click="rememberFather">
                    {{ $t("Manage requests") }}
                </router-link>
            </div>
            <div v-else-if="notification.data.type === 'room_join_accepted'" class="notification-box">
                {{ $t("You have been given access to join room") }}: {{ notification.data.roomName }}
                <router-link class="d-flex justify-content-end external-link me-2"
                    :to="{ name: 'room', params: { roomId: notification.data.roomId } }"
                    @click="rememberFather">
                    {{ $t("Go to room") }}
                </router-link>
            </div>
            <div v-else-if="notification.data.type === 'unread_messages_on_room'" class="notification-box">
                {{ $t("You have unread messages in") }}: {{ notification.data.roomName }}
                <router-link class="d-flex justify-content-end external-link me-2"
                    :to="{ name: 'room', params: { roomId: notification.data.roomId } }"
                    @click="rememberFather">
                    {{ $t("Go to room") }}
                </router-link>
            </div>
            <div v-else class="notification-box">
                <p>{{ $t("Unknown notification.") }}</p>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { saveIntoLocalStorage } from "@/utils/local-storage";
import { isRoomFatherRoute } from "@/utils/breadcrumb";

export default defineComponent({
    name: "NotificationModal",
    props: {
        message: String,
    },
    setup() {
        return {
            timeout: null,
        };
    },
    data: function () {
        return {
            shown: false,
            notification: null,
        };
    },
    methods: {
        rememberFather: function () {
            const name = this.$route.name ? String(this.$route.name) : "";
            if (isRoomFatherRoute(name)) {
                saveIntoLocalStorage("father-id", name);
            }
        },
        show: function (notification: any) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.shown = true;
            this.notification = notification;

            this.timeout = setTimeout(() => {
                this.shown = false;
            }, 6000);
        },

        hide: function () {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.shown = false;
        },
    },
    mounted: function () {
        this.$listenOnAppEvent("show-notification", this.show.bind(this));
    },
    beforeUnmount: function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    },
});
</script>
